import { useState } from 'react'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { Dialog, DialogTitle, DialogContent, Backdrop } from '@material-ui/core'
import {
  EditCoprosGeneralNews,
  ListCoprosGeneralNews,
} from './copros/copros_general_news'

export const CoproNewsList = () => {
  const [idGeneralNews, setIdGeneralNews] = useState(false)
  const [openNewsDialog, setOpenNewsDialog] = useState(true)

  return (
    <>
      <ListCoprosGeneralNews
        empty={<></>}
        pagination={null}
        resource="copros_general_news"
        rowClick={(id, resource, record) => {
          setOpenNewsDialog(true)
          setIdGeneralNews(id)
        }}
      />
      {idGeneralNews && (
        <Dialog
          PaperProps={{
            style: {
              width: '650px',
            },
          }}
          open={openNewsDialog}
        >
          <DialogTitle style={{ paddingBottom: '0px', textAlign: 'center' }}>
            EDITING NEWS #{idGeneralNews}
          </DialogTitle>
          <CloseRoundedIcon
            aria-label="Close"
            onClick={() => setOpenNewsDialog(false)}
            sx={{
              position: 'absolute',
              top: '1em',
              right: '1em',
              float: 'right',
              cursor: 'pointer',
            }}
          />
          <EditCoprosGeneralNews
            resource="copros_general_news"
            id={idGeneralNews}
            redirect={false}
            mutationMode="pessimistic"
            mutationOptions={{
              onSuccess: () => {
                setIdGeneralNews(null)
              },
            }}/>
        </Dialog>
      )}
    </>
  )
}
